<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
export default {
  name: 'Result2',
  components: {
    VRuntimeTemplate
  },
  props: {
    step: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  async created () {
    if (isEmpty(wepHtmlToString.sixthSubTemplate)) {
      this.getEmptyTemplate('wepResult2.html')
    } else {
      this.includeHtml = wepHtmlToString.sixthSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.sixthSubTemplate = res
        this.includeHtml = wepHtmlToString.sixthSubTemplate
      })
    },
    fnTab () {
      this.fnMove(this.step)
    },
    fnApply () {
      if (isEmpty(wepHtmlToString.firstSubTemplate)) {
        this.fnMove('2')
      } else {
        this.fnMove('1')
      }
    },
    fnMove (arg) {
      let obj = {
        stepNum: arg,
        params: {
        }
      }
      this.$emit('fnTab', obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Result2.vue